import { ElementType, PropsWithChildren } from 'react';
import { Box, BoxProps } from '@mui/material';
import { Breakpoint, SystemStyleObject, Theme } from '@mui/system';

interface IMainContainerProps extends Omit<BoxProps, 'component'> {
  sx?: SystemStyleObject<Theme>;
  size?: Breakpoint;
  component?: ElementType;
}

const MainContainer = ({
  children,
  size = 'md',
  sx,
  component = 'div',
  ...rest
}: PropsWithChildren<IMainContainerProps>) => {
  return (
    <Box
      component={component}
      sx={theme => ({
        mx: 'auto',
        maxWidth: theme.breakpoints.values[size],
        width: '100%',
        padding: 2,
        ...sx,
      })}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default MainContainer;
